import {aseWebsocketCommands} from '../../constants/aseWebsocketCommands';

export const fetchAseDealers = () => (dispatch) => {
    dispatch({
        type: aseWebsocketCommands.ASE_DEALERS_GET,
        aseWebsocket: true,
        command: aseWebsocketCommands.ASE_DEALERS_GET,
        payload: {}
    });
};

// Websocket-based dealer search
export const searchAseDealers = (searchTerm) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const correlationId = `search_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            
            let timeoutId;
            let intervalId;
            
            const checkForResults = () => {
                const state = getState();
                const { searchResults } = state.aseExportDealers || {};
                
                if (searchResults && searchResults.correlationId === correlationId) {
                    if (timeoutId) clearTimeout(timeoutId);
                    if (intervalId) clearInterval(intervalId);
                    resolve(searchResults.dealers || []);
                    return true;
                }
                return false;
            };
            
            dispatch({
                type: aseWebsocketCommands.ASE_DEALERS_GET,
                aseWebsocket: true,
                command: aseWebsocketCommands.ASE_DEALERS_GET,
                payload: { searchTerm, correlationId }
            });
            
            intervalId = setInterval(() => {
                if (checkForResults()) {
                    return;
                }
            }, 100);
            
            timeoutId = setTimeout(() => {
                if (intervalId) clearInterval(intervalId);
                reject(new Error('Search timeout'));
            }, 10000);
            
            checkForResults();
        });
    };
};
